<template>
  <div class="animated fadeIn">
    <report-search-options :periodOption=true @search="onSearch"/>

    <b-card  v-if="visitorsData">
      <b-btn type="submit" @click="printReceipt" variant="success">Print</b-btn>
      <hr/>
      <ag-grid-vue class="ag-theme-balham"
        :gridOptions="gridOptions"
        :rowData="visitorsData"
        :pagination="true"
        :paginationPageSize="20"
        :suppressNoRowsOverlay="true"
        :floatingFilter="true"
        @gridReady="gridReady">
      </ag-grid-vue>
    </b-card>

    <b-card desk class="card-columns" v-if="labels.length">
    <b-row>
      <b-col sm="6" offset-sm="3">
        <b-card header="Total Count">
          <div class="chart-wrapper">
            <bar-chart :visitData="chartData" :labels="labels" :periodType="periodType"></bar-chart>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-card>

  

  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapState, mapActions } from 'vuex'
  import {AgGridVue} from "ag-grid-vue"
  import ReportSearchOptions from './components/ReportSearchOptions'
  import BarChart from './components/bar-chart'

  const receiptShape = {
    receiptType: "samadhclosingreport",
    familtyTotal: 0,
    groupTotal: 0,
    singleTotal: 0,
    studentTotal: 0,
    blankTotal: 0,
    overallTotal: 0,
    period: "None",
    periodType: ""
  }
  export default {
    components: {
      AgGridVue,
      ReportSearchOptions,
      BarChart
    },
    data: function () {
      return {
        visitorsData: null,
        chartData : [],
        labels: [],
        periodType: "",
        receipt: Object.assign({}, receiptShape),
        gridOptions: {
          context: {
            componentParent: this
          },
          defaultColDef: {
            sortable: true,
            resizable: true,
            filter: 'agTextColumnFilter',
            minWidth: 120
          },
          columnDefs: [
           {headerName: 'Period', field: 'period' },
           {headerName: 'Family Total', field: 'familtyTotal'},
           {headerName: 'Group Total', field: 'groupTotal'},
           {headerName: 'Single Total', field: 'singleTotal'},
           {headerName: 'Student Total', field: 'studentTotal'},
           {headerName: 'Other Total', field: 'blankTotal'},
           {headerName: 'Overall Total', field: 'overallTotal'}
         ]
       }
      }
    },
    methods:{
      onSearch(data) {
        this.chartData = [];
        this.labels = [];
        this.periodType = ""
        this.$store.dispatch('samadh/getEntryVisitors', data)
         .then(response => {
           this.visitorsData = response.data.data
           if (this.visitorsData.length > 0) {
                _.forEach(this.visitorsData, (item) => {
                  this.periodType = item.periodType
                  this.labels.push(item.period)
                  this.chartData.push(item.overallTotal)                
                })
              }
           this.showSuccessMsg()      
           
         })
         .catch((error) => {
           if (error.response.status == 400) {
             this.showErrorMsg({
               message: error.response.data.message
             })
           }
           else if (error.response.status == 422){
               this.showErrorMsg({
                 message: error.response.data.message
               });
           }
           else {
             this.showErrorMsg()
           }

         })

      },
      gridReady(){
      //   this.gridOptions.api.sizeColumnsToFit();
      },
      callReceiptService(){
        this.$nextTick(() => {
         let params = JSON.stringify(this.receipt);
         console.log(params);
         this.$store.dispatch('samadh/printReceipt', params)
           .then((response) => {
             console.log(response.data.status);
             if(response.data.status == 'error'){
                 if(response.data.message != null){
                   this.showErrorMsg({
                   message: "Print Failed: " + response.data.message
                 });
                 }
                 else{
                   this.showErrorMsg({
                     message: "Print Failed. Please check Print service is running."
                   });
                 }

               }
               else{
                 this.showSuccessMsg({
                   message: "Print Successful."
                 });
               }
           })
           .catch((error) => {
             if(error.response != null && error.response.data.message != null){
               this.showErrorMsg({
                 message: "Print Failed: " + error.response.data.message
               });
             }
             else{
               this.showErrorMsg({
                 message: "Print Failed. Please check Print service is running."
               });
             }

           })
     });

     },
     async printReceipt(){
       let data = this.visitorsData[0];
       if(data != null && !this.isEmpty(data)){
         this.receipt.familtyTotal = data.familtyTotal;
         this.receipt.groupTotal = data.groupTotal;
         this.receipt.singleTotal = data.singleTotal;
         this.receipt.studentTotal = data.studentTotal;
         this.receipt.overallTotal = data.overallTotal;
         this.receipt.period =  data.period;
         this.receipt.blankTotal =  data.blankTotal;
         this.receipt.periodType = data.periodType;

         await this.callReceiptService();
      }
      else{
        this.showErrorMsg({
          message: "No searched records found for print."
        });
      }

     },
     isEmpty(obj) {
       for(var key in obj) {
           if(obj.hasOwnProperty(key))
               return false;
       }
       return true;
     }

    },

  }
</script>
